var exports = {
  "kL": "x24da60e8--eef29f--container",
  "v8": "x24da60e8--eef29f--with-max-width",
  "DD": "x24da60e8--eef29f--title",
};

module.exports = exports;
